import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IAmmendment } from 'src/app/models/IPersonalInfo';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { SharedService } from 'src/app/Sharedservice/SharedService';

@Component({
  selector: 'app-view-ammendments-notes',
  templateUrl: './view-ammendments-notes.component.html',
  styleUrls: ['./view-ammendments-notes.component.css']
})
export class ViewAmmendmentsNotesComponent implements OnInit {
  ViewAmmendmentForm: FormGroup;
  AcceptRejectedBy: string = "";
  statusType: string = "";
  ammendmentNotes: string;
  isDisableRejectReason: boolean = true;
  constructor(private formBuilder: FormBuilder, private toastr: ToastrService,
    private messageService: MessagesService, private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService, public dialog: MatDialog
    , public dialogRef: MatDialogRef<ViewAmmendmentsNotesComponent>) {

  }

  ngOnInit() {
    this.getPatientRequestDetails();
  }
  ammendmentList: IAmmendment[] = [];
  getPatientRequestDetails() {
    this.sharedService.getAmmendmentNoteInformation('', '', CommonComponents.encounterId)
      .subscribe(
        (ammendment: any) => {
          this.ammendmentList = ammendment;
          if (ammendment.length > 0) {

          }
        },
        (err: any) => {
          console.log(err);
        });
  }
  onNoClick() {
    this.dialogRef.close()
  }
}
